import { BaseService } from '../../../core/services/BaseServices';
import { AxiosPromise } from 'axios';

export class VApiStatusService extends BaseService {
  constructor() {
    super('vapi/apiStatus');
  }
  public getAll(type: string): AxiosPromise<any[]> {
    return this.httpAxios
      .get(type, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }
}

const vApiStatusService = new VApiStatusService();

export default vApiStatusService;
